module.exports = __webpack_public_path__ + "img/icon2.855f1e26.gif";